import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Traditional%20Korean%20palace%20courtyard%20at%20golden%20hour%20with%20ancient%20stone%20lanterns%20and%20graceful%20roof%20curves%2C%20soft%20warm%20sunlight%20casting%20long%20shadows%2C%20serene%20and%20scholarly%20atmosphere%20with%20distant%20mountains%2C%20cultural%20elegance%20and%20timeless%20wisdom&width=1600&height=900&seq=hero-bg-main&orientation=landscape')`,
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/45"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-20">
        <div className="inline-flex items-center gap-2 bg-background-50/15 backdrop-blur-sm border border-background-50/20 rounded-full px-5 py-2 mb-8">
          <i className="ri-sparkling-2-line text-accent-400 text-sm"></i>
          <span className="text-background-50 text-sm font-medium">东亚伦理文化的深度解读</span>
        </div>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-6 leading-tight">
          韩国伦理
          <br />
          <span className="text-accent-300">深度解析韩国伦理文化与价值观</span>
        </h1>

        <p className="text-background-50/70 text-base md:text-lg max-w-2xl mx-auto mb-10 leading-relaxed">
          全面了解韩国伦理的核心内涵，涵盖儒家伦理传统、现代韩国伦理观念演变、
          家庭与社会伦理规范，以及韩国伦理在影视、职场、人际关系中的实际体现
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/rujia-lunli-chuantong"
            className="px-8 py-3.5 bg-primary-500 text-background-50 rounded-lg font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            开始探索
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <a
            href="#categories"
            className="px-8 py-3.5 bg-background-50/10 text-background-50 border border-background-50/25 rounded-lg font-medium text-sm hover:bg-background-50/20 transition-colors cursor-pointer whitespace-nowrap"
          >
            浏览分类
            <i className="ri-arrow-down-line ml-2"></i>
          </a>
        </div>
      </div>
    </section>
  );
}